import { SVGProps, Ref, forwardRef } from 'react';

export const PlayFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.49 13.262c-2.03 1.058-3.046 1.587-3.768.985S3 12.27 3 9.52V6.48c0-2.75 0-4.125.722-4.727s1.738-.073 3.769.985l2.919 1.52C13.47 5.852 15 6.648 15 8s-1.53 2.148-4.59 3.742zM4.45 13.1h-.008.012zm.004-10.2h-.012z"
                fill="currentColor"
            />
        </g>
    </svg>
));
PlayFilledSize16Glyph.displayName = 'PlayFilledSize16Glyph';
